export default __webpack_public_path__ + "static/media/3-6-1.e7fe3838.webp";